<template>
  <div>
    <datatable
      @create="createLanguage"
      @delete="deleteLanguage"
      title="Position Languages"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'position-languages',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'language_name',
          value: 'language.name'
        },
        {
          name: 'reading',
          value: 'reading'
        },
        {
          name: 'writing',
          value: 'writing'
        },
        {
          name: 'verbal',
          value: 'verbal'
        },
        {
          name: 'reading_importance',
          value: 'reading_importance'
        },
        {
          name: 'writing_importance',
          value: 'writing_importance'
        },
        {
          name: 'verbal_importance',
          value: 'verbal_importance'
        }
      ],
      data: [],
      operations: [],
      position_id: this.$route.query.position_id,
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getPositionLanguages({
          current_company_id: this.company_id,
          position_id: this.position_id
        })
        .then(response => {
          this.data = response
        })
    },
    deleteLanguage (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.name,
        item_name: delete_data.name,
        method: 'deletePositionLanguage',
        method_params: { id: delete_data.id, position_id: this.position_id, current_company_id: this.company_id }
      })
    },
    createLanguage () {
      this.create({ designator: 'position-languages-form-modal', component_name: 'PositionLanguagesForm', is_create: true, position_id: this.position_id, company_id: this.company_id, modal_title: 'Create new Language', position_status: this.$route.query.position_status })
    },
    editClick (data) {
      this.create({ designator: 'position-languages-form', component_name: 'PositionLanguagesForm', data, modal_title: data.language.name, position_id: this.position_id, company_id: this.company_id, position_status: this.$route.query.position_status })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
